import { getPersistedRoute } from "@/hooks/use-route-persistance";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/",
)({
  beforeLoad: ({ params }) => {
    const persistedRoute = getPersistedRoute(params.company, "payable");

    if (persistedRoute) {
      throw redirect({ to: persistedRoute, replace: true });
    }

    throw redirect({
      to: "/$company/buchhaltung/eingang/uploads",
      params: { company: params.company },
      replace: true,
    });
  },
});
